<!--  -->
<template>
  <div class="contact-btn">
    <template v-if="type === 'bottom'">
      <button
        class="btn hvr-pulse-shrink"
        :style="{
          padding: 'unset',
          width: width,
          height: height,
          fontSize: fontSize,
          borderRadius: borderRadius,
          backgroundColor: backgroundColor,
        }"
        @click="open">
        <slot name="default"> 立即沟通 </slot>
      </button>
    </template>
    <template v-else>
      <span class="btn-text" :style="{ fontSize: fontSize }" @click="open">
        <slot name="default"> 了解更多智能视频服务 → </slot>
      </span>
    </template>
    <Form v-model="show" />
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import Form from "@/components/Form/index.vue";

  export default {
    name: "",
    mixins: [],
    // import引入的组件需要注入到对象中才能使用
    components: {
      Form,
    },
    props: {
      type: {
        type: [String],
        default: "bottom",
      },
      width: {
        type: [String],
        default: "120px",
      },
      height: {
        type: [String],
        default: "38px",
      },
      fontSize: {
        type: [String],
        default: "18px",
      },
      borderRadius: {
        type: [String],
        default: "8px",
      },
      backgroundColor: {
        type: [String],
        default: "#08c6ad",
      },
      // 自定义按钮事件
      customBtnClick: {
        type: [Function],
        default: null,
      },
    },
    data() {
      // 这里存放响应式数据
      return {
        show: false,
      };
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    activated() {}, // 如果页面有keep-alive缓存功能，这个函数会激活时调用
    deactivated() {}, // 如果页面有keep-alive缓存功能，这个函数会停用时调用
    // 方法集合
    methods: {
      open() {
        if (typeof this.customBtnClick === "function") {
          this.customBtnClick.call();
        } else {
          this.show = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn {
    // background: $main-color;
    color: #fff;
    font-size: 13px;
    font-weight: 600;

    &:hover {
      background: $minor-color !important;
    }

    &:focus,
    &.focus {
      outline: 0;
      box-shadow: unset;
    }
  }

  .btn-text {
    color: $main-color;
    cursor: pointer;
  }
</style>
